import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { ShipManagementCompanyPayload, ShipManagementCompanyResponse } from "@/types/interface/ship-management-company";

export const useShipManagementCompanyStore = defineStore("shipManagementCompanyStore", () => {
  const company = ref<ShipManagementCompanyResponse>();
  const companies = ref<ShipManagementCompanyResponse[]>([]);

  function initCompanies(data: any) {
    companies.value = data?.data;
  }

  function addNewCompany(data: any) {
    company.value = data;
  }

  async function dispatchGetList(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipManagementCompany.getShipManagementCompany(page, limit, queryParam);
      if (status === 200 ) {
        initCompanies(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idShipManagementCompany = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipManagementCompany.findShipManagementCompany(idShipManagementCompany);
      if (status === 200 ) {
        addNewCompany(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: ShipManagementCompanyPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipManagementCompany.createShipManagementCompany(payload);
      if (status === 200 ) {
        addNewCompany(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idShipManagementCompany = "", payload: ShipManagementCompanyPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipManagementCompany.updateShipManagementCompany(idShipManagementCompany, payload);
      if (status === 200 ) {
        addNewCompany(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idShipManagementCompany = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.shipManagementCompany.deleteShipManagementCompany(idShipManagementCompany);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    company,
    companies,
    initCompanies,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetList,
    dispatchDelete
  };
});